export default __webpack_public_path__ + "static/media/ArrowRight.e71b0d20.svg";